<div *ngIf="selectedRouteExpand" class="container component">
    
    <div class="linia bar baroptions">
        <options class="slim mixed-text-icon" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
    </div>
    
    <div *ngIf="actualOptionId!='DELIVERY' && actualOptionId!='ORDERSHIPMENTSINROUTE' && !selectedRouteExpand.isTrucked && !selectedRouteExpand.isBrokenForTrucking" class="block-buttons">
        <button class="action broken"
            (click)="onBrokenRoute()">{{ 'TRUCKING.ROUTE.ACTION.BROKENROUTE.CAPTION' | translate}}</button>
    </div>
    <div *ngIf="actualOptionId!='DELIVERY' && actualOptionId!='ORDERSHIPMENTSINROUTE' && selectedRouteExpand.isBrokenForTrucking" class="block-buttons">
        <button class="action unbroken"
            (click)="onUnBrokenRoute()">{{ 'TRUCKING.ROUTE.ACTION.UNBROKENROUTE.CAPTION' | translate}}</button>
    </div>

    <div class="block-options">
        <div class="llista">
            <ng-container *ngIf="actualOptionId==='PACKAGE'">
                <div class="overflow">
                    <shared-trucking-package-card class="package-item shipmentcard" 
                        *ngFor="let package of selectedRouteExpand.packages" [selectedRouteExpand]="selectedRouteExpand" [package]="package" 
                        (clickCard)="onClickPackage($event)"
                        [ngClass]="{'selected':selectedPackage!=null && package.packageId==selectedPackage.packageId}"
                        [isDraggable]="false" (refresh)="onRefreshShipmentList($event)">
                    </shared-trucking-package-card>
                </div>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='SHIPMENT'">
                <div class="overflow">
                    <shared-trucking-shipment-card class="shipment-item routedetail"
                        *ngFor="let shipment of selectedRouteExpand.shipments" [selectedRouteExpand]="selectedRouteExpand" [shipment]="shipment"
                        (clickCard)="onClickShipment($event)" 
                        [ngClass]="{'selected':selectedShipment!=null && shipment.shipmentId==selectedShipment.shipmentId}">
                    </shared-trucking-shipment-card>
                </div>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='DELIVERY'">
                <shared-documentaryreview-route-item [routeId]="selectedRouteExpand.routeId">
                </shared-documentaryreview-route-item>
            </ng-container>
            <ng-container *ngIf="actualOptionId==='ORDERSHIPMENTSINROUTE'">
                <shared-route-shipment-order [routeId]="selectedRouteExpand.routeId" [onlyvieworder]="true">
                </shared-route-shipment-order>
            </ng-container>
        </div>
    </div>
</div>